import { toNumberFormat } from "../../utils/numberFormat";

const getHeightMeasureText = (d) => {
  if (!d) return "-";
  if (d === "severe_stunted") return "เตี้ยแคระแกร็น";
  if (d === "stunted") return "เตี้ย";
  if (d === "relatively_stunted") return "ค่อนข้างเตี้ย";
  if (d === "normal") return "ตามเกณฑ์";
  if (d === "quite_high") return "ค่อนข้างสูง";
  if (d === "high") return "สูง";

  return "-";
};

const getWeightMeasureText = (d) => {
  if (!d) return "-";
  if (d === "severe_wasted") return "ผอมแห้ง";
  if (d === "wasted") return "ผอม";
  if (d === "relatively_wasted") return "ค่อนข้างผอม";
  if (d === "normal") return "สมส่วน";
  if (d === "buxom") return "ท้วม";
  if (d === "overweight") return "เริ่มอ้วน";
  if (d === "obese") return "อ้วน";

  return "-";
};

const individualColumns = [
  {
    title: "สัปดาห์ที่",
    dataIndex: "week",
    key: "week",
  },
  {
    title: "นมวัวจืด ml/วัน",
    dataIndex: "freshMilkVolume",
    key: "freshMilkVolume",
    render: (v) => <>{toNumberFormat(v)}</>,
  },
  {
    title: "นมวัวปรุงแต่ง ml/วัน",
    dataIndex: "flavoredMilkVolume",
    key: "flavoredMilkVolume",
    render: (v) => <>{toNumberFormat(v)}</>,
  },
  {
    title: "นมวัวรวม ml/วัน",
    dataIndex: "totalMilkVolume",
    key: "totalMilkVolume",
    render: (v) => <>{toNumberFormat(v)}</>,
  },
  {
    title: "นมถั่วเหลืองจืด ml/วัน",
    dataIndex: "soyMilkVolume",
    key: "soyMilkVolume",
    render: (v) => <>{toNumberFormat(v)}</>,
  },
  {
    title: "นมถั่วเหลืองหวาน ml/วัน",
    dataIndex: "soyMilkSweetVolume",
    key: "soyMilkSweetVolume",
    render: (v) => <>{toNumberFormat(v)}</>,
  },
  {
    title: "คะแนนรวม เป้าหมายที่ 1",
    dataIndex: "totalCowMilkScore",
    key: "totalCowMilkScore",
    render: (v) => <>{toNumberFormat(v)}</>,
  },
  {
    title: "ผัก ช้อน/วัน",
    dataIndex: "totalVegetableQuantity",
    key: "totalVegetableQuantity",
    render: (v) => <>{toNumberFormat(v)}</>,
  },
  {
    title: "คะแนนรวม เป้าหมายที่ 2",
    dataIndex: "totalVegetableScore",
    key: "totalVegetableScore",
    render: (v) => <>{toNumberFormat(v)}</>,
  },
  {
    title: "ออกกำลัง นาที/วัน",
    dataIndex: "totalExerciseMinutes",
    key: "totalExerciseMinutes",
    render: (v) => <>{toNumberFormat(v)}</>,
  },
  {
    title: "คะแนนรวม เป้าหมายที่ 3",
    dataIndex: "totalExerciseScore",
    key: "totalExerciseScore",
    render: (v) => <>{toNumberFormat(v)}</>,
  },
  {
    title: "น้ำหวาน ml/วัน",
    dataIndex: "normalSweetDrinkVolume",
    key: "normalSweetDrinkVolume",
    render: (v) => <>{toNumberFormat(v)}</>,
  },
  {
    title: "น้ำหวาน หวานน้อย ml/วัน",
    dataIndex: "lowSweetDrinkVolume",
    key: "lowSweetDrinkVolume",
    render: (v) => <>{toNumberFormat(v)}</>,
  },
  {
    title: "คะแนนรวม เป้าหมายที่ 4",
    dataIndex: "totalSweetDrinkScore",
    key: "totalSweetDrinkScore",
    render: (v) => <>{toNumberFormat(v)}</>,
  },
  {
    title: "ส่วนสูง (ซม.)",
    dataIndex: "height",
    key: "height",
  },
  {
    title: "น้ำหนัก (กก.)",
    dataIndex: "weight",
    key: "weight",
  },
  {
    title: "ประเมินส่วนสูงล่าสุด",
    dataIndex: "heightForAge",
    key: "heightForAge",
    render: (heightForAge) => {
      return <>{getHeightMeasureText(heightForAge)}</>;
    },
  },
  {
    title: "ประเมินน้ำหนักล่าสุด",
    dataIndex: "weightForHeight",
    key: "weightForHeight",
    render: (weightForHeight) => {
      return <>{getWeightMeasureText(weightForHeight)}</>;
    },
  },
  {
    title: "คะแนนการทำแบบทดสอบชุดความรู้",
    dataIndex: "quizScore",
    key: "quizScore",
    render: (quizScore) => <>{toNumberFormat(quizScore)}</>,
  },
  {
    title: "% คะแนนการทำแบบทดสอบชุดความรู้",
    dataIndex: "quizScorePercent",
    key: "quizScorePercent",
    render: (quizScorePercent) => <>{toNumberFormat(quizScorePercent)}</>,
  },
  // {
  //   title: "จำนวนข้อมูลที่กรอก (วัน)",
  //   dataIndex: "days",
  //   key: "days",
  // },
  // {
  //   title: "รางวัลที่ได้รับ",
  //   dataIndex: "rewards",
  //   key: "rewards",
  //   render: (rewards) => {
  //     return <span>{rewards && rewards.join(", ")}</span>;
  //   },
  // },
  // {
  //   title: "Rank",
  //   dataIndex: "rank",
  //   key: "rank",
  // },
];

const collectiveColumns = [
  {
    title: "ชื่อ/ชื่อเล่น",
    dataIndex: "User.nickname",
    key: "nickname",
  },
  {
    title: "นมวัวจืด ml/วัน",
    dataIndex: "freshMilkVolume",
    key: "freshMilkVolume",
    render: (v) => <>{toNumberFormat(v)}</>,
  },
  {
    title: "นมวัวปรุงแต่ง ml/วัน",
    dataIndex: "flavoredMilkVolume",
    key: "flavoredMilkVolume",
    render: (v) => <>{toNumberFormat(v)}</>,
  },
  {
    title: "นมวัวรวม ml/วัน",
    dataIndex: "totalMilkVolume",
    key: "totalMilkVolume",
    render: (v) => <>{toNumberFormat(v)}</>,
  },
  {
    title: "นมถั่วเหลืองจืด ml/วัน",
    dataIndex: "soyMilkVolume",
    key: "soyMilkVolume",
    render: (v) => <>{toNumberFormat(v)}</>,
  },
  {
    title: "นมถั่วเหลืองหวาน ml/วัน",
    dataIndex: "soyMilkSweetVolume",
    key: "soyMilkSweetVolume",
    render: (v) => <>{toNumberFormat(v)}</>,
  },
  {
    title: "คะแนนรวม เป้าหมายที่ 1",
    dataIndex: "totalCowMilkScore",
    key: "totalCowMilkScore",
    render: (v) => <>{toNumberFormat(v)}</>,
  },
  {
    title: "ผัก ช้อน/วัน",
    dataIndex: "totalVegetableQuantity",
    key: "totalVegetableQuantity",
    render: (v) => <>{toNumberFormat(v)}</>,
  },
  {
    title: "คะแนนรวม เป้าหมายที่ 2",
    dataIndex: "totalVegetableScore",
    key: "totalVegetableScore",
    render: (v) => <>{toNumberFormat(v)}</>,
  },
  {
    title: "ออกกำลัง นาที/วัน",
    dataIndex: "totalExerciseMinutes",
    key: "totalExerciseMinutes",
    render: (v) => <>{toNumberFormat(v)}</>,
  },
  {
    title: "คะแนนรวม เป้าหมายที่ 3",
    dataIndex: "totalExerciseScore",
    key: "totalExerciseScore",
    render: (v) => <>{toNumberFormat(v)}</>,
  },
  {
    title: "น้ำหวาน ml/วัน",
    dataIndex: "normalSweetDrinkVolume",
    key: "normalSweetDrinkVolume",
    render: (v) => <>{toNumberFormat(v)}</>,
  },
  {
    title: "น้ำหวาน หวานน้อย ml/วัน",
    dataIndex: "lowSweetDrinkVolume",
    key: "lowSweetDrinkVolume",
    render: (v) => <>{toNumberFormat(v)}</>,
  },
  {
    title: "คะแนนรวม เป้าหมายที่ 4",
    dataIndex: "totalSweetDrinkScore",
    key: "totalSweetDrinkScore",
    render: (v) => <>{toNumberFormat(v)}</>,
  },
  {
    title: "ส่วนสูง (ซม.)",
    dataIndex: "height",
    key: "height",
  },
  {
    title: "น้ำหนัก (กก.)",
    dataIndex: "weight",
    key: "weight",
  },
  {
    title: "ประเมินส่วนสูงล่าสุด",
    dataIndex: "heightForAge",
    key: "heightForAge",
    render: (heightForAge) => {
      return <>{getHeightMeasureText(heightForAge)}</>;
    },
  },
  {
    title: "ประเมินน้ำหนักล่าสุด",
    dataIndex: "weightForHeight",
    key: "weightForHeight",
    render: (weightForHeight) => {
      return <>{getWeightMeasureText(weightForHeight)}</>;
    },
  },
  {
    title: "คะแนนการทำแบบทดสอบชุดความรู้",
    dataIndex: "quizScore",
    key: "quizScore",
    render: (v) => <>{toNumberFormat(v)}</>,
  },
  {
    title: "% คะแนนการทำแบบทดสอบชุดความรู้",
    dataIndex: "quizScorePercent",
    key: "quizScorePercent",
    render: (v) => <>{toNumberFormat(v)}</>,
  },
  // {
  //   title: "ประเมินส่วนสูงล่าสุด",
  //   dataIndex: "heightForAge",
  //   key: "heightForAge",
  //   render: (heightForAge) => {
  //     return <>{getHeightMeasureText(heightForAge)}</>;
  //   },
  // },
  // {
  //   title: "ประเมินน้ำหนักล่าสุด",
  //   dataIndex: "weightForHeight",
  //   key: "weightForHeight",
  //   render: (weightForHeight) => {
  //     return <>{getWeightMeasureText(weightForHeight)}</>;
  //   },
  // },
  // {
  //   title: "จำนวนข้อมูลที่กรอก (วัน)",
  //   dataIndex: "days",
  //   key: "days",
  // },
  // {
  //   title: "รางวัลที่ได้รับ",
  //   dataIndex: "rewards",
  //   key: "rewards",
  //   render: (rewards) => {
  //     return <span>{rewards && rewards.join(", ")}</span>;
  //   },
  // },
  // {
  //   title: "Rank",
  //   dataIndex: "rank",
  //   key: "rank",
  // },
];

const chartOption = {
  title: {
    text: "nameeee",
    align: "center",
    style: {
      fontSize: "16px",
      fontWeight: "bold",
      fontFamily: "Noto Sans Thai, Noto Sans",
      color: "#058459",
      marginLeft: "50px",
    },
  },
  chart: {
    id: "reportChart",
    offsetX: -20,
    locales: [
      {
        name: "en",
        toolbar: {
          download: "ดาวน์โหลด",
        },
      },
    ],
    toolbar: {
      show: false,
      offsetX: -100,
      offsetY: 450,
      tools: {
        download: `<button class="download-btn"> ดาวน์โหลด</button>`,
        selection: false,
        zoom: false,
        zoomin: false,
        zoomout: false,
        pan: false,
        reset: false | '<img src="/static/icons/reset.png" width="20">',
        customIcons: [],
      },
      export: {
        csv: {
          filename: undefined,
          columnDelimiter: ",",
          headerCategory: "category",
          headerValue: "value",
          dateFormatter(timestamp) {
            return new Date(timestamp).toDateString();
          },
        },
        svg: {
          filename: undefined,
        },
        png: {
          filename: undefined,
        },
      },
    },
  },
  xaxis: {
    type: "number",
    tickAmount: 8,
    min: 0,
    max: 16,
    title: {
      text: "สัปดาห์",
      style: {
        class: "",
      },
    },
  },
  yaxis: {
    tickAmount: 9,
    title: {
      text: "คะแนน",
      rotate: 0,
      offsetX: 30,
      offsetY: -198,
    },
    min: 0,
    max: 18,
    labels: {
      /**
       * Allows users to apply a custom formatter function to yaxis labels.
       *
       * @param { String } value - The generated value of the y-axis tick
       * @param { index } index of the tick / currently executing iteration in yaxis labels array
       */
      formatter: function (val, index) {
        return val.toFixed(0);
      },
    },
  },
  legend: {
    show: false,
  },
};

const csvIndividualHeaders = individualColumns.map((item) => ({
  label: item.title,
  key: item.key,
}));

const csvCollectiveHeaders = collectiveColumns.map((item) => ({
  label: item.title,
  key: item.key,
}));

export {
  getHeightMeasureText,
  getWeightMeasureText,
  individualColumns,
  collectiveColumns,
  chartOption,
  csvIndividualHeaders,
  csvCollectiveHeaders,
};
